"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logWarning = exports.ErrorWithStatus = exports.Status = void 0;
var Status;
(function (Status) {
    Status[Status["Ok"] = 0] = "Ok";
    Status[Status["BadRequest"] = 1] = "BadRequest";
    Status[Status["NotFound"] = 2] = "NotFound";
    Status[Status["Unavailable"] = 3] = "Unavailable";
    Status[Status["Unauthorized"] = 4] = "Unauthorized";
    Status[Status["Gone"] = 5] = "Gone";
    Status[Status["UriTooLong"] = 6] = "UriTooLong";
    Status[Status["InternalServerError"] = 7] = "InternalServerError";
    Status[Status["ServiceUnavailable"] = 8] = "ServiceUnavailable";
    Status[Status["RequestTimeout"] = 9] = "RequestTimeout";
})(Status = exports.Status || (exports.Status = {}));
class ErrorWithStatus extends Error {
    status;
    props;
    constructor(m, status, props) {
        super(m);
        this.name = "ErrorWithStatus";
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorWithStatus);
        }
        this.status = status;
        this.props = props;
    }
}
exports.ErrorWithStatus = ErrorWithStatus;
function logWarning(err, log) {
    switch (err.status) {
        case Status.BadRequest:
            log.error("_app.tsx BadRequest:", err.stack || err);
            break;
        case Status.NotFound:
            log.warn("_app.tsx NotFound:", err.stack || err);
            break;
        case Status.Unavailable:
            log.warn("_app.tsx Unavailable:", err.stack || err);
            break;
        case Status.Unauthorized:
            log.warn("_app.tsx Unauthorized:", err.stack || err);
            break;
        case Status.Gone:
            log.warn("_app.tsx Gone:", err.stack || err);
            break;
        case Status.UriTooLong:
            log.warn("_app.tsx UriTooLong:", err.stack || err);
            break;
        case Status.InternalServerError:
            log.warn("_app.tsx InternalServerError:", err.stack || err);
            break;
        case Status.ServiceUnavailable:
            log.warn("_app.tsx ServiceUnavailable:", err.stack || err);
            break;
        case Status.RequestTimeout:
            log.warn("_app.tsx RequestTimeout:", err.stack || err);
            break;
        case Status.Ok:
            break;
    }
}
exports.logWarning = logWarning;
//# sourceMappingURL=logging.js.map